import { render, staticRenderFns } from "./shortcodeTestimonial.vue?vue&type=template&id=3843cd53&"
import script from "./shortcodeTestimonial.vue?vue&type=script&lang=js&"
export * from "./shortcodeTestimonial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports